module.exports = __webpack_public_path__ + "img/3_5_combo.559e277e.png";